import React, { Component } from 'react';
import { View, StyleSheet, Image } from 'react-native';
import DRNText from '../../../standard/Text/DRNText';
import PropTypes from 'prop-types';
import R from '../../../core-res/R';
import { isActive, isCompleted } from '../utils/getItemStatus';
import { INDEX_INDICATOR_DIMENSION } from '../utils/BreadCrumbConst';
class IndexIndicator extends Component {
    constructor() {
        super(...arguments);
        this.getBackgroundColor = () => {
            const { theme, index, activeEventIndex } = this.props;
            if (isActive(index, activeEventIndex)) {
                return theme.lightPrimary;
            }
            return theme.brand;
        };
        this.getTextColor = () => {
            const { theme, index, activeEventIndex } = this.props;
            if (isActive(index, activeEventIndex)) {
                return theme.textPrimaryInteractive;
            }
            return theme.borderSubtle;
        };
        this.renderCompleteIndicator = () => {
            const { style } = this.props;
            return (<View style={[styles.indexIndicator, styles.checkmarkImageWrapper, style]}>
        <Image source={require('../../../../images/checkmark.png')} style={styles.checkmarkImage}/>
      </View>);
        };
    }
    render() {
        const { theme, index, style, activeEventIndex } = this.props;
        const borderColor = theme.lightPrimary;
        const backgroundColor = this.getBackgroundColor();
        const color = this.getTextColor();
        if (isCompleted(index, activeEventIndex))
            return this.renderCompleteIndicator();
        return (<View style={[{ borderColor }, styles.indexIndicator, { backgroundColor }, style]}>
        <DRNText style={[styles.indexIndicatorText, { color }]}>{index + 1}</DRNText>
      </View>);
    }
}
IndexIndicator.propTypes = {
    theme: PropTypes.object,
    index: PropTypes.number.isRequired,
    style: PropTypes.object,
    activeEventIndex: PropTypes.number.isRequired,
};
const styles = StyleSheet.create({
    indexIndicator: {
        justifyContent: 'center',
        alignItems: 'center',
        height: INDEX_INDICATOR_DIMENSION,
        width: INDEX_INDICATOR_DIMENSION,
        borderRadius: INDEX_INDICATOR_DIMENSION / 2,
        borderWidth: R.border.width.thick,
    },
    indexIndicatorText: Object.assign({}, R.typography.uiBaseline, { lineHeight: 22 }),
    checkmarkImage: {
        width: 10,
        height: 7,
    },
    checkmarkImageWrapper: {
        backgroundColor: R.color.uiGreenPrimary,
        borderColor: R.color.uiGreenPrimary,
    },
});
export default IndexIndicator;
